import request from '@/utils/request';

export function saveOrUpdatePopupAd(data) {
  return request({
    url: '/popup/ad/saveOrUpdatePopupAd',
    method: 'POST',
    data
  });
}
export function fetchPopupAdDetail(data) {
  return request({
    url: '/popup/ad/fetchPopupAdDetail',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/popup.js